import * as Ids from '@utils/ids'; // eslint-disable-line import/no-cycle
import { getCookie } from '@utiljs/cookie';

/**
 * horn配置项 数据结构
 */
interface ICommoneHornGrayConfig {
    /**白名单列表（账号或者门店id） */
    openList: Array<{
        wmPoiId?: string;
        acctId?: string;
        unionId?: string;
        deviceUuid?: string;
    }>;
    /**黑名单列表（账号或者门店id） */
    closeList: Array<{
        wmPoiId?: string;
        acctId?: string;
        unionId?: string;
        deviceUuid?: string;
    }>;
    /** 万分比 */
    percent: number;
    /**
     * 万分比维度，默认acctId
     *  不同维度计算规则如下：
     *  - acctId: 将 acctId 转为 Number 后按 10000 取模
     *  - device_uuid：首先利用 hashCode 方法将 device_uuid 字符串转换为 Number，然后按 10000 取模
     */
    percentType?: 'acctId' | 'deviceUuid';
}

/**
 * Java 语言中 String.hashCode() 方法的 JavaScript 实现
 *
 * 出处：https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 */
const hashCode = (str: string): number => {
    let hash = 0;
    for (let i = 0, len = str.length; i < len; i++) {
        const chr = str.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = (hash << 5) - hash + chr;
        // eslint-disable-next-line no-bitwise
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

/**
 * 1. 判断是否命中灰度
 * 2. grayConfig:horn相关灰度配置项内容(数据结构需要满足ICommoneHornGrayConfig接口，详细参看：https://horn.sankuai.com/files/edit/4502)
 * 3. 命中规则优先级：黑名单（closeList） > 白名单（openList） > 账号id命中（percent）
 */
const isHitGray = function(grayConfig: ICommoneHornGrayConfig | null): boolean {
    let isHitCanary = false;
    if (grayConfig !== null) {
        const wmPoiId = Ids.getWmPoiId();
        const acctId = Ids.getAcctId();
        const deviceUuid = getCookie('device_uuid');
        const unionId =
            getCookie('uuid') ||
            getCookie('unionid') ||
            getCookie('dpid') ||
            getCookie('_lxsdk_cuid');

        const { openList = [], closeList = [], percent = 0, percentType = 'acctId' } = grayConfig;
        // 完全关闭
        if (percent === 0) {
            isHitCanary = false;
        } else {
            let generalHashCode = 0;
            if (percentType === 'deviceUuid' && deviceUuid !== '') {
                generalHashCode = Math.abs(hashCode(deviceUuid));
            } else if (acctId !== '') {
                // 使用 acctId 维度兜底
                generalHashCode = Number(acctId);
            }

            const rem = generalHashCode % 10000;
            if (!Number.isNaN(rem) && rem < percent) {
                isHitCanary = true;
            }
        }

        // 命中白名单
        for (let i = 0; i < openList.length; i++) {
            if (
                openList[i].wmPoiId === wmPoiId ||
                openList[i].acctId === acctId ||
                openList[i].unionId === unionId ||
                openList[i].deviceUuid === deviceUuid
            ) {
                isHitCanary = true;
            }
        }
        // 命中黑名单
        for (let i = 0; i < closeList.length; i++) {
            if (
                closeList[i].wmPoiId === wmPoiId ||
                closeList[i].acctId === acctId ||
                closeList[i].unionId === unionId ||
                closeList[i].deviceUuid === deviceUuid
            ) {
                isHitCanary = false;
            }
        }
    }
    return isHitCanary;
};
export { isHitGray, ICommoneHornGrayConfig };
